module.exports = function routeLocalization(supportedLocales = ['en']) {
    return (req, res, next) => {
        const parts = req.url.split('/');
        if (parts.length > 1 && supportedLocales.includes(parts[1])) {
            req.locale = parts[1];
            req.url = '/' + parts.slice(2).join('/');
            if (req.url === '') req.url = '/';
        }
        next();
    };
};
